module.exports = __webpack_public_path__ + "img/month.201040e2.svg";